import React from "react"
import { StaticImage } from "gatsby-plugin-image"

import { externalLinks } from "../../../_V2/common/links"

import styles from "./styles.module.scss"

export const socialNetworkBanner = {
	icon: (
		<StaticImage
			className={styles.icon}
			src="./assets/BusinessMoneyFoodIcon.png"
			width={84}
			alt="Логотип"
			objectFit="cover"
			placeholder="none"
			quality={90}
		/>
	),
	heading: "Поболтаем?",
	textarea: "Вступайте в Телеграм-чат для рестораторов и экспертов HoReCa",
	social: {
		heading: "Бизнес, деньги, общепит",
		textarea: (
			<>
				<span className={styles.textarea__desktop}>Чат для рестораторов и экспертов</span>
				<span className={styles.textarea__mobile}>Чат для рестораторов и экспертов HoReCa</span>
			</>
		),

		url: externalLinks.restoBusinessChat,
	},
}
